<template>
  <RCard class="title-list">
    <AgGrid :options="gridOptions" :row-data="titleList">
      <template #header>
        <Grid gaf="column" justify-content="space-between" class="q-mb-lg">
          <div class="text-subtitle-1 text-secondary-2 q-ml-sm q-mt-sm">ITEMS</div>

          <RBtn type="link" :to="titleListLink"> Add from Products title list </RBtn>
        </Grid>
      </template>
    </AgGrid>
  </RCard>
</template>

<script>
import * as apiTo from '@/modular-api'
import { numericSorter, dateSorter, associatedItemsRenderer, dateRenderer } from '@/lib/generic.utils'
// Libraries
import { mapGetters } from 'vuex'
// Components
import AgGrid from '@/ag-grid/AgGrid'

export default {
  components: {
    AgGrid
  },

  props: {
    id: [Number, String] // from route
  },

  data: () => ({
    titleList: null
  }),

  computed: {
    ...mapGetters('subscription-show', ['subscription']),

    titleListLink() {
      return `/products/${this.subscription?.product?.id}/title-lists`
    },

    gridOptions() {
      return {
        columnDefs: [
          {
            headerName: 'Name',
            field: 'name',
            tooltipField: 'name',
            editable: false,
            cellRendererFramework: 'LinkRenderer',
            cellRendererParams: params => {
              return {
                route: `/title-lists/${params.data.id}`
              }
            }
          },
          {
            headerName: 'Valid from',
            field: 'valid_from',
            type: 'centerAligned',
            comparator: dateSorter,
            cellRenderer: params => dateRenderer(params.value),
            tooltipValueGetter: params => dateRenderer(params.value)
          },
          {
            headerName: 'Valid To',
            field: 'valid_to',
            type: 'centerAligned',
            comparator: dateSorter,
            cellRenderer: params => dateRenderer(params.value),
            tooltipValueGetter: params => dateRenderer(params.value)
          },
          {
            headerName: 'Titles',
            field: 'publications_count',
            type: 'rightAligned',
            comparator: numericSorter,
            tooltipValueGetter: params => associatedItemsRenderer(params.value, 'publication', 'publications')
          }
        ],
        defaultColDef: {
          resizable: false,
          floatingFilter: false
        },
        domLayout: 'autoHeight'
      }
    }
  },

  watch: {
    subscription: {
      handler: 'getTitleLists',
      immediate: true
    }
  },

  methods: {
    getTitleLists(subscription) {
      if (!subscription) return
      apiTo.GET_PRODUCTS_TITLE_LISTS(this.subscription.product.id).then(({ data }) => (this.titleList = data.result))
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/mixins';

.title-list {
  @include table-with-no-filters;
}
</style>
